var beneficiaryStates = {
    default: 1,
    flaggedForRemoval: 0,
    removed: -1
};

export default beneficiaryStates;
